import React, {useEffect, useLayoutEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setSelectedHetPay, GetCustomerDetailsForBusinessContactManager, LockUnlockNpStatus} from '../PortalsBlock/portalSlice';
import {validateSelectedAccount, SubscriberErrorEnum} from '../BusinessWorkOrderSystem/BusinessWorkOrderSystemSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import TextInputWithButton from '../../Shared/TextInputWithButton/TextInputWithButton';
import '../../Shared/TextInputWithButton/TextInputWithButton.scss';
import PopUp from '../../Shared/Popup/PopUp';
import Image from 'app/Components/Shared/Image/image';
import likeIcon from '../PortalsBlock/images/icon-like/icon-100-like.svg';
import errorIcon from '../PortalsBlock/images/icon-error/icon-120-error.svg';
import lockUnlockNpOpenIcon from './images/lock-unlock-np.svg';
import lockUnlockNpLockedIcon from './images/lock-unlock-np-locked.svg';
import Config from '../../../Config';
import '../../Shared/ValidationInputsWithRadio/ValidationInputsWithRadio.scss';
import './LockUnlockNpRent.scss';
const isValidPhoneNumber = (phoneNumber) => /^\d{10}$/.test(phoneNumber) && phoneNumber.startsWith('05');
const getOrgId = (portalsBlock) => {
  if (portalsBlock?.selectedHetPayId) {
    return portalsBlock.selectedHetPayId.trim();
  }
  return portalsBlock?.privateCompanyList
    ?.find((company) => company.idNumber === portalsBlock.selectedHetPay)
    ?.orgId?.trim();
};
const LockUnlockNpRent = ({
  iContent,
  context,
  portalsBlock,
  selectedHetPay,
  validateSelectedAccount,
  setSelectedHetPay,
  GetCustomerDetailsForBusinessContactManager,
  LockUnlockNpStatus,
  showAppLoader,
  hideAppLoader,
}) => {

  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState(null);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [lockUnlockNp, setLockUnlockNp] = useState('');
  const [customerBan, setCustomerBan] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const navigateToBusinessLobby = async () => {
    const content = await context.loadContentByPath(Config.businessLobbyUrl);
    context.navigateTo(content);
  };

  useLayoutEffect(() => {
    if (!selectedHetPay) {
      navigateToBusinessLobby();
    }
  }, []);

  useEffect(() => {
    if (selectedHetPay) {
      setSelectedHetPay(selectedHetPay);
    }
  }, [selectedHetPay, setSelectedHetPay]);

  const handleValidation = async () => {
    if (!phoneNumber) {
      setError('שדה חובה');
      return;
    }

    if (!isValidPhoneNumber(phoneNumber)) {
      setError('אנא הזן מספר טלפון תקין');
      return;
    }

    const orgId = getOrgId(portalsBlock);

    if (!orgId) {
      setError('לא נמצא מזהה ארגון');
      return;
    }

    setIsLoading(true);
    setIsValidated(false);
    setLockUnlockNp('');
    setCustomerBan('');
    setShowErrorPopup(false);
    const result = await validateSelectedAccount({
      subscriber: phoneNumber,
      orgId,
    });

    if (!result.payload?.isAllowed) {
      setIsLoading(false);
      setError(result.payload?.error || SubscriberErrorEnum.Unknown);
      setIsValidated(false);
      return;
    }
    const resultDetails = await GetCustomerDetailsForBusinessContactManager({
      orgId,
      customerNumber: phoneNumber,
      formType: 'PHONE',
    });

    setIsLoading(false);
    setError(null);
    setIsValidated(true);
    setLockUnlockNp(resultDetails.payload?.lockUnlockNp || '');
    setCustomerBan(resultDetails.payload?.customerBan || '');
  };

  const handleLockUnlockNp = async () => {

    if (!customerBan) {
      setShowErrorPopup(true);
      return;
    }
    
    const lockUnlockNpAction = lockUnlockNp === 'lock' ? 'unlock' : 'lock';

    showAppLoader();
    setShowErrorPopup(false);

    const result = await LockUnlockNpStatus({
      ban: customerBan,
      subscriberNumber: phoneNumber,
      actionType: lockUnlockNpAction,
    });

    hideAppLoader();

    if (result.payload?.error) {
      setShowErrorPopup(true);
      return;
    }

    setLockUnlockNp(lockUnlockNpAction);
    setShowSuccessPopup(true);
  };

  const handleSuccessPopupClose = async () => {
    setShowSuccessPopup(false);
    await navigateToBusinessLobby();
  };

  const handleErrorPopupClose = async () => {
    setShowErrorPopup(false);
    await navigateToBusinessLobby();
  };

  return (
    <div className='lock-unlock-np-rent client-information-main lock-unlock-np-rent'>
      <div className='validate-business-phone'>
        <div className='text-center headline-component'>
          <h2 dangerouslySetInnerHTML={{__html: iContent.title.value}} className='text-center' />
          <h1 dangerouslySetInnerHTML={{__html: iContent.boldTitle.value}} className='bold text-center' />
        </div>
        <div className='lock-unlock-np-form'>
            <div className='text-input'>
              <TextInputWithButton
                placeholder='מספר טלפון'
                value={phoneNumber}
                maxLength='10'
                pattern='05[0-9]{8}'
                type='text'
                inputMode='numeric'
                required
                error={error}
                isLoading={isLoading}
                isValidated={isValidated}
                disabled={isLoading}
                btnDisabled={!isValidPhoneNumber(phoneNumber)}
                buttonAction={handleValidation}
                onChange={(e) => {
                  const numberRegex = /^\d+$/;
                  if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target.value.length <= 10) {
                    setPhoneNumber(e.target.value);
                    setIsValidated(false);
                    setLockUnlockNp('');
                    setCustomerBan('');
                    setShowErrorPopup(false);
                    if (error) {
                      setError(null);
                    }
                  }
                }}
              />
            </div>
          {isValidated && lockUnlockNp && (
            <div className='text-input np-action'>
              <div className='toggle-container'>
                <Image
                  className='np-status-icon'
                  src={lockUnlockNp === 'lock' ? lockUnlockNpLockedIcon : lockUnlockNpOpenIcon}
                  alt={lockUnlockNp === 'lock' ? 'חסום לניוד' : 'פתוח לניוד'}
                />
                <div className='switch-container'>
                  <div className='switch'>
                    <div
                      className={lockUnlockNp === 'unlock' ? 'selected' : 'unselected'}
                      onClick={lockUnlockNp === 'lock' ? handleLockUnlockNp : null}
                    >
                      {lockUnlockNp === 'unlock' ? 'פתוח לניוד' : 'פתיחה לניוד'}
                    </div>
                    <div
                      className={lockUnlockNp === 'unlock' ? 'unselected' : 'selected'}
                      onClick={lockUnlockNp === 'unlock' ? handleLockUnlockNp : null}
                    >
                      {lockUnlockNp === 'unlock' ? 'חסימה לניוד' : 'חסום לניוד'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {showErrorPopup && (
        <PopUp
          preventWrapperClose={false}
          showPopUp={showErrorPopup}
          onClose={() => setShowErrorPopup(false)}
          footerBtn={{
            text: 'חזרה לאיזור האישי',
            onBtnClick: handleErrorPopupClose,
          }}>
          <div className='client-information-change-hetPay-text text-center'>
            <Image src={errorIcon} alt='שגיאה' />
            <div className='title'>אירעה שגיאה בעת ביצוע הפעולה.</div>
            <div className='title'>נא לפנות לתמיכה.</div>
          </div>
        </PopUp>
      )}
      {showSuccessPopup && (
        <PopUp
          preventWrapperClose={false}
          showPopUp={showSuccessPopup}
          onClose={() => setShowSuccessPopup(false)}
          footerBtn={{
            text: 'חזרה לאיזור האישי',
            onBtnClick: handleSuccessPopupClose,
          }}>
          <div className='client-information-change-hetPay-text text-center'>
            <Image src={likeIcon} alt='הצלחה' />
            <div className='title'>הפעולה בוצעה בהצלחה</div>
            <div className='light-note'>לצפייה בעדכון שביצעת, יש להמתין מספר דקות ולבצע שליפה מחדש.</div>
          </div>
        </PopUp>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  portalsBlock: state.portalsBlock,
  selectedHetPay: state.portalsBlock.selectedHetPay,
});

const mapDispatchToProps = {
  validateSelectedAccount,
  setSelectedHetPay,
  GetCustomerDetailsForBusinessContactManager,
  LockUnlockNpStatus,
  showAppLoader,
  hideAppLoader,
};
export default connect(mapStateToProps, mapDispatchToProps)(LockUnlockNpRent);